import styled from '@emotion/styled';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  margin: 0 10px 0 40px;
  overflow: hidden;
  max-height: 0;
  transition: max-height 0.3s ease-out;


  &.open {
    max-height: max-content;

    transition: max-height 0.6s ease-in;
  }
`;
